var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"black","max-width":_vm.maxWidth,"nudge-bottom":_vm.nudgeBottom},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({ref:"text",staticClass:"ellipses-text",domProps:{"innerHTML":_vm._s(_vm.text)}},'span',attrs,false),_vm.showTooltip ? on : null))]}}])},[_vm._v(" "),(_vm.showTooltip)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }